// src/components/Navbar.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import "./Navbar.css";

const Navbar = () => {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">Jade</Link>
      </div>
      <div className="navbar-links">
        <Link to="/">Home</Link>
        <Link to="/games">All Games</Link>
        {isAuthenticated && <Link to="/account">My Account</Link>}
        {isAuthenticated && user?.["https://gamehub.com/roles"]?.includes("Admin") && (
          <Link to="/admin">Admin</Link>
        )}
      </div>
      <div className="navbar-auth">
        {isAuthenticated ? (
          <>
            <span>👋 {user?.nickname}</span>
            <button onClick={() => logout({ returnTo: window.location.origin })}>
              Logout
            </button>
          </>
        ) : (
          <button onClick={loginWithRedirect}>Login</button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
